import { render, staticRenderFns } from "./insertrecord.vue?vue&type=template&id=21b8aa82&scoped=true&"
import script from "./insertrecord.vue?vue&type=script&lang=js&"
export * from "./insertrecord.vue?vue&type=script&lang=js&"
import style0 from "./insertrecord.vue?vue&type=style&index=0&id=21b8aa82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8aa82",
  null
  
)

export default component.exports